export const getCountryCode = async (nomPays) => {
    const country = nomPays ? nomPays : "France"
    try {
      const response = await fetch(`https://restcountries.com/v3.1/name/${encodeURIComponent(country)}?fields=cca2`);
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération du pays');
      }
      const data = await response.json();
      return data[0]?.cca2 || null;
    } catch (error) {
      console.error('Erreur:', error);
      return null;
    }
};

/**
 * Vérifie si la date passée correspond à un jour férié ou à un week-end.
 * @param {Date} date - La date à vérifier.
 * @param {Array} publicHolidays - Tableau de chaînes de caractères représentant les jours fériés au format "YYYY-MM-DD".
 * @returns {boolean} - true si le jour est un week-end ou férié, false sinon.
 */
export function isNonBusinessDay(date, publicHolidays = []) {
  const day = date.getDay();
  const dateStr = date.toISOString().slice(0, 10);
  return day === 0 || day === 6 || publicHolidays.includes(dateStr);
}

/**
 * Calcule la date estimée de livraison en fonction d'un délai exprimé en heures.
 * 
 * Logique :
 * - Si la commande est passée avant 13h00 et que le jour courant n'est pas un week-end ni un jour férié,
 *   on ajoute directement le délai (lead time) à l'heure actuelle.
 * - Sinon, on démarre le calcul à 9h00 le jour suivant et on y ajoute ensuite le délai.
 * 
 * Les jours fériés et week-ends sont « comptabilisés » dans le délai lorsque celui-ci est ajouté.
 *
 * @param {number} leadTimeHours - Le délai en heures à ajouter.
 * @param {Array} publicHolidays - Tableau de jours fériés au format "YYYY-MM-DD".
 * @returns {Date} - La date estimée de livraison.
 */
export function getEstimatedDeliveryDate(leadTimeHours, publicHolidays = []) {
  const now = new Date();
  const todayStr = now.toISOString().slice(0, 10);
  const isBusinessDayToday = now.getDay() !== 0 && now.getDay() !== 6 && !publicHolidays.includes(todayStr);

  let startDate;
  if (isBusinessDayToday && now.getHours() < 13) {
    // Commande passée avant 13h et en journée ouvrée → départ immédiat
    startDate = now;
  } else {
    // Sinon, le calcul démarre le jour suivant à 9h00
    startDate = new Date(now);
    startDate.setDate(startDate.getDate() + 1);
    startDate.setHours(9, 0, 0, 0);
  }

  // Ajout continu du délai, sans exclusion de week-end ou de jour férié
  const estimatedDate = new Date(startDate.getTime() + leadTimeHours * 3600000);
  return estimatedDate;
}

/**
 * Formate une date selon le format français.
 * Exemple : "lundi 14 septembre 2025"
 *
 * @param {Date} date - La date à formater.
 * @returns {string} - La date formatée.
 */
export function formatDate(date) {
  return date.toLocaleDateString("fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
